import React from 'react';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: "MasterControl, Inc.",
      position: "Senior Software Engineer",
      duration: "Apr 2025 - Present",
      description: [
        "Architected production system integrating LLM reasoning with structured enterprise data.",
        "Established deterministic correctness via tool orchestration and response validation against source-of-truth data.",
        "Implemented observability pipeline (JUnit + OpenTelemetry + Grafana) to measure system reliability and regression behavior.",
        "Optimized event processing latency from >5s to <500ms by redesigning Redis pipeline for real-time workflows.",
        "Defined forward-compatible interface layer enabling migration from internal APIs to external tool protocols.",
        "Directed technical approach for reliable AI feature rollout from prototype to production."
      ]
    },
    {
      company: "Meta Platforms Inc.",
      position: "Software Engineer (L5)",
      duration: "Mar 2024 - Apr 2025",
      description: [
        "Developed enterprise identity service for managed organizations in a multi-service distributed environment.",
        "Maintained services in high-scale production with strict correctness and access-control requirements.",
        "Aligned API rollout strategy with multiple platform teams to ensure safe deployment."
      ]
    },
    {
      company: "Amazon.com, Inc. and its affiliates",
      position: "Software Development Engineer II",
      duration: "Oct 2020 - Mar 2024",
      description: [
        "Implemented automated verification workflows preventing fraudulent brand registrations, reducing abuse by 40%.",
        "Introduced workflow automation service reducing manual review time (AHT) by 70%.",
        "Led cross-team design reviews to reduce tech debt and launch customer-facing verification features across 3 teams.",
        "Developed backend APIs, UI workflows and reporting for Brand Enrollment and IP protection.",
        "🏆 Awarded Deliver Results at Q3 All Hands 2023 for automation reducing Ops load by 40%."
      ]
    },
    {
      company: "DoorDash (via Wollborg Michelson)",
      position: "Software Development Lead / Architect",
      duration: "July 2020 - Oct 2020",
      description: [
        "Delivered real-time data pipeline for DoorDash Safety & Security enabling operational decision-making.",
        "Coordinated stakeholders to revise data capture methods and implement supporting architecture."
      ]
    },
    {
      company: "Phoenix CubeSat — NASA Space Grant, Arizona State University",
      position: "Flight Software Engineer",
      duration: "Dec 2018 - May 2020",
      description: [
        "Delivered ASU CubeSat under NASA Space Grant program for urban thermal mapping across 7 US cities.",
        "Engineered C-based downlink algorithms achieving <1% packet loss on constrained hardware."
      ]
    },
    {
      company: "TATA Consultancy Services Ltd.",
      position: "Software Developer / Engineer",
      duration: "Sep 2011 - July 2018",
      description: [
        "Built enterprise-scale data platforms across telecom clients in Malaysia & Saudi Arabia.",
        "🏆 Engineered high-performance analytics system supporting 1.6M+ projects, improving query runtime by 20×.",
        "Produced automated ETL pipelines and executive dashboards.",
        "Trained 200+ enterprise users across Saudi Telecom and Telekom Malaysia."
      ]
    }
  ];

  const education = [
    {
      institution: "Arizona State University",
      degree: "Master of Science (MS) — Information Technology",
      duration: "2018 - 2020",
      achievement: "GPA: 4.0/4.0"
    },
    {
      institution: "KIIT University",
      degree: "Bachelor of Technology (B.Tech) — Mechanical Engineering",
      duration: "2007 - 2011",
      achievement: ""
    }
  ];

  return (
    <section className="experience">
      <h1>Professional Journey</h1>

      <h2>Work Experience</h2>
      <div className="timeline">
        {experiences.map((exp, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-content">
              <h3>{exp.position}</h3>
              <h4>{exp.company}</h4>
              <p className="duration">{exp.duration}</p>
              <ul className="experience-list">
                {exp.description.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <h2>Education</h2>
      <div className="timeline">
        {education.map((edu, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-content">
              <h3>{edu.degree}</h3>
              <h4>{edu.institution}</h4>
              <p className="duration">{edu.duration}</p>
              {edu.achievement ? <p className="achievement">{edu.achievement}</p> : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
